(function () {
    'use strict';


    angular
        .module('isFromVentePrivee', [])

        /* @ngInject */
        .directive('isFromVentePrivee', function () {
            return {
                restrict: 'A',
                controllerAs: 'isFromVentePriveeCtrl',

                /* @ngInject */
                controller: ["$scope", "$rootScope", "$cookies", "ModalService", function ($scope, $rootScope, $cookies, ModalService) {
                    var ctrl = this;

                    ctrl.$onInit = function () {

                        if ($cookies.get('cookiesVP')) {

                            ModalService.show(
                                '/Template/Authentication/ModalAuthenticationVentePrivee',
                                null,
                                null,
                                'loginModalCtrlVentePrivee'
                            );
                            
                        };

                        $cookies.remove('cookiesVP');
                        console.log('remove cookieVP');

                    };

                    //$scope.$on('fromVentePrivee', function () {
                    //    console.log('popup popup popup popup');
                    //    alert('popup popup');
                    //});

                    //$scope.$on('fromVentePrivee22', function () {
                    //    console.log('22222222');
                    //    alert('popup 22222222 popup');
                    //});



                }]
            };
        });

})();


